import mismatchesEs from './es/mismatches.json';
import mismatchesEn from './en/mismatches.json';

export const codMismatchesEs = mismatchesEs;
export const codMismatchesEn = mismatchesEn;

